module.exports = __webpack_public_path__ + "static/img/gxx.981d5a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/gxx.jpg
// module id = VUlB
// module chunks = 0